import React from 'react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9998] bg-stabeon-danger/90 backdrop-blur-sm px-4 py-2 text-center">
      <p className="text-white text-xs font-semibold">
        You're offline — data may not sync
      </p>
    </div>
  );
}
